import React from 'react';
import PageNav from './PageNav';
import CityNav from './CityNav';
import Story from './Story';
import content from '../content/content.js';
import useKeypress from 'react-use-keypress';

export default function Bottom(props) {

  // console.log(props);

  // page indicator classes
  var pageClass;
  if (props.page === 0) {
    pageClass = 'pageNumber pageHide'
  } else {
    pageClass = 'pageNumber pageShow'
  }

  function passUp(stuff){
    props.onChange(stuff)
  }

  var c1 = props.cities.findIndex(city => city === props.pageCity1);
  var c2 = props.cities.findIndex(city => city === props.pageCity2);
  var activeProf = (props.page === 3) && (props.direction === 'next') ? 'primaryschoolteacher' : undefined

  useKeypress('ArrowLeft', () => {
    passUp({s: 'page', v: -1})
    if (c1) {passUp({s: 'city1', v: c1});};
    if (c2) {passUp({s: 'city2', v: c2});};
    if (activeProf) {passUp({s: 'activeProf', v: activeProf})};
  });

  useKeypress('ArrowRight', () => {
    if (props.page !== 9) {
      passUp({s: 'page', v: 1})
      if (c1) {passUp({s: 'city1', v: c1});};
      if (c2) {passUp({s: 'city2', v: c2});};
      if (activeProf) {passUp({s: 'activeProf', v: activeProf})};
    }
  });

  return (
    <div className="Bottom">
      <p className={pageClass}>{props.page+1} / {content.pages.length}</p>
      <div className="BottomContainer">
        <PageNav
          type="prev"
          cities={props.cities}
          page={props.page}
          onChange={passUp}
          prev={props.prev}
          next={props.next}
          city1={props.pageCity1}
          city2={props.pageCity2}
        />
        <Story
          direction={props.direction}
          page={props.page}
          show={props.show ? props.show.story : undefined}
          prev={props.prev ? props.prev.story : undefined}
          next={props.next ? props.next.story : undefined}
        />
        <CityNav
          onChange={passUp}
          cities={props.cities}
          page={props.page}
          type="1"
          city={props.city1}
          prev={props.prev}
          next={props.next}
          direction={props.direction}
        />
        <CityNav
          onChange={passUp}
          cities={props.cities}
          page={props.page}
          type="2"
          city={props.city2}
          prev={props.prev}
          next={props.next}
          direction={props.direction}
        />
        <PageNav
          type="next"
          cities={props.cities}
          page={props.page}
          onChange={passUp}
          prev={props.prev}
          next={props.next}
          city1={props.pageCity1}
          city2={props.pageCity2}
          direction={props.direction}
        />
      </div>
    </div>
  )
};
